export default __webpack_public_path__ + "static/media/issuer-instagram.c80a6566.svg";